/*
 * Method to overide normal Variant render with extra fields
 */

class VariantRadiosExtended extends VariantRadios {
    constructor() {
        super();
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);
        
                if (source && destination) destination.innerHTML = source.innerHTML;
        
                const price = document.getElementById(`price-${this.dataset.section}`);
        
                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

                const idStock = `stock-availability-${this.dataset.section}`;

                const destinationStock = document.getElementById(idStock);
                const sourceStock = html.getElementById(idStock);

                if (sourceStock && destinationStock) destinationStock.innerHTML = sourceStock.innerHTML;

                const idDetails = `details-cell-${this.dataset.section}`;

                const destinationDetails = document.getElementById(idDetails);
                const sourceDetails = html.getElementById(idDetails);

                if (sourceDetails && destinationDetails) destinationDetails.innerHTML = sourceDetails.innerHTML;

        });
    }
}
  
customElements.define('variant-radios-extended', VariantRadiosExtended);